import { BeneficiaryQuery, Beneficiaries } from './beneficiaryInterfaces';

export const transformToBeneficiaries = (
  data: BeneficiaryQuery['data']
): Beneficiaries => {
  const beneficiaries: Beneficiaries = {
    age: undefined,
    ethnic: undefined,
    gender: undefined,
    health: undefined,
    social: undefined,
    work: undefined
  };
  data.forEach(d => {
    switch (d.bdtName) {
      case 'Adults':
      case 'Nineteen and older':
      case 'Seniors':
      case 'Children and youth':
      case 'Children':
      case 'Adolescents': {
        const beneficiaryAge = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.age) {
          beneficiaries.age.categories.push(beneficiaryAge);
        } else {
          beneficiaries.age = {
            categories: [beneficiaryAge]
          };
        }
        break;
      }
      case 'People of African descent':
      case 'People of Latin American descent':
      case 'People of European descent':
      case 'Multiracial people':
      case 'People of Asian descent':
      case 'Indigenous peoples':
      case 'People of Middle Eastern descent': {
        const beneficiaryEthnic = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.ethnic) {
          beneficiaries.ethnic.categories.push(beneficiaryEthnic);
        } else {
          beneficiaries.ethnic = {
            categories: [beneficiaryEthnic]
          };
        }
        break;
      }
      case 'Males':
      case 'Females':
      case 'LGBTQ': {
        const beneficiaryGender = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.gender) {
          beneficiaries.gender.categories.push(beneficiaryGender);
        } else {
          beneficiaries.gender = {
            categories: [beneficiaryGender]
          };
        }
        break;
      }
      case 'People with disabilities':
      case 'People with diseases and illnesses':
      case 'Substance abusers': {
        const beneficiaryHealth = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.health) {
          beneficiaries.health.categories.push(beneficiaryHealth);
        } else {
          beneficiaries.health = {
            categories: [beneficiaryHealth]
          };
        }
        break;
      }
      case 'Immigrants and migrants':
      case 'Economically disadvantaged people':
      case 'At-risk youth':
      case 'Homeless people':
      case 'Extremely poor people':
      case 'Victims and oppressed people':
      case 'Incarcerated people': {
        const beneficiarySocial = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.social) {
          beneficiaries.social.categories.push(beneficiarySocial);
        } else {
          beneficiaries.social = {
            categories: [beneficiarySocial]
          };
        }
        break;
      }
      case 'Students':
      case 'Unemployed people':
      case 'Veterans':
      case 'Self-employed people':
      case 'Retired people':
      case 'Domestic workers':
      case 'Military personnel':
      case 'Farmers':
      case 'Artists and performers':
      case 'Emergency responders':
      case 'Teachers': {
        const beneficiaryWork = {
          name: d.bdtName,
          percentage: d.percentage
        };
        if (beneficiaries.work) {
          beneficiaries.work.categories.push(beneficiaryWork);
        } else {
          beneficiaries.work = {
            categories: [beneficiaryWork]
          };
        }
        break;
      }
    }
  });
  return beneficiaries;
};
